export default __webpack_public_path__ + "static/media/auteuil7.e21e3d16.jpg";